import React, { useContext, useState } from "react";

const Global = React.createContext();

export default function UserProvider({ children }) {
  const [user, setUser] = useState({});
  const [field, setField] = useState(-1);
  const [fields, setFields] = useState([]);
  const [hasDashboard, setHasDashboard] = useState(false);
  const storage = { user, setUser, field, setField, fields, setFields, hasDashboard, setHasDashboard };
  return <Global.Provider value={storage}>{children}</Global.Provider>;
}

function useGlobal() {
  return useContext(Global);
}

export { useGlobal };